import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants/apiRoutes";
import { LoginResponse, LoginUserPayload } from "./interface";

export const login = (payload: LoginUserPayload): Promise<LoginResponse> => {
	return axios.post(API_ROUTES.AUTH.LOGIN, payload);
};
